import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    document.fonts.ready.then(() => {
      requestAnimationFrame(() => this.setup())
    })
  }

  setup() {
    this.activeIndex = 1

    // Entrance: stagger tabs in from below
    gsap.set(this.tabTargets, {
      autoAlpha: 0,
      y: 20
    })

    ScrollTrigger.create({
      trigger: this.tabTargets[0]?.parentElement,
      start: "top 85%",
      once: true,
      onEnter: () => {
        gsap.to(this.tabTargets, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.08,
          ease: "power2.out"
        })
      }
    })
  }

  select(event) {
    const index = parseInt(
      event.currentTarget.dataset.index
    )
    if (this.activeIndex === index) return

    const outgoing = this.panelTargets[
      this.activeIndex
    ]
    const incoming = this.panelTargets[index]
    this.activeIndex = index

    // Update tab styles
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("bg-white", "text-black")
        tab.classList.remove(
          "bg-transparent", "text-gray-400",
          "border-gray-700",
          "hover:text-white",
          "hover:border-gray-500"
        )
      } else {
        tab.classList.remove(
          "bg-white", "text-black"
        )
        tab.classList.add(
          "bg-transparent", "text-gray-400",
          "border-gray-700",
          "hover:text-white",
          "hover:border-gray-500"
        )
      }
    })

    // Hide outgoing immediately, animate incoming
    if (outgoing) {
      outgoing.classList.add("hidden")
      gsap.set(outgoing, { autoAlpha: 1, x: 0 })
    }

    if (incoming) {
      incoming.classList.remove("hidden")
      gsap.fromTo(incoming,
        { autoAlpha: 0, x: 30 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.4,
          ease: "power2.out"
        }
      )
    }
  }
}
